<template>
    <div class="flex-col">
        <vnavbar title="评分详情" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header">
            <div class="patient">
                <div class="name">{{surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo.sex||'--'}}/{{surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
            <div class="more"><div class="moredevice">{{surgeryInfo.surgeries}}</div><div @click="isShowMore=!isShowMore">查看更多<span><i :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div></div>
            <div v-if="isShowMore" class="surgery">
                <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                <div>科室:{{surgeryInfo.dic_section}}</div>
                <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                <div>手术医生:{{surgeryInfo.surgeon}}</div>
                <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD HH:mm:ss`)}}</div>
            </div>
            </div>
        </div>
        <div v-if="scoreList && scoreList.length>0" class="scrollContent" :style="{'height':`${this.isShowMore? (this.screenHeight - 324):(this.screenHeight - 173)}px`}">
            <div class="header" style="height: 40px;background-color: aliceblue !important;text-align: center;color: black !important;font-size: x-large;font-weight: 500;">
                {{scoreInfo && scoreInfo.name}}
            </div>
            <div class="content flex-col" v-if="scoreInfo && scoreInfo.details && scoreInfo.details.length>0" :style="{'height':`${this.isShowMore? (this.screenHeight - 370):(this.screenHeight - 220)}px`}">
                <div v-for="(item, i) in scoreInfo.details" :key="i" style="padding-left: 10px;">
                    <div class="question" style="text-align: left;height: 40px;display: flex;align-items: center;" v-show="item.question && item.question!=``">{{ item.question }}</div>
                    <vradiogroup v-model="item.value">
                        <vradio v-for="(citem, j) in item.options" :key="j" :name="citem.value" @click="scoreClick(item, citem.value)" style="text-align: left;font-size: medium;">{{ citem.lable }}</vradio>
                    </vradiogroup>
                </div>
            </div>
            <div v-else>
                <vempty description="暂无数据" class="empty" />
            </div>
            <div class="bottom">
                <div class="lblScore">
                {{ScoreSum}}
                </div>
                <vbutton class="btnSave" type="info" @click="savescore()">保存</vbutton>
            </div>
        </div>
    </div>
</template>

<script>
import { NavBar as vnavbar, Empty, Button as vbutton, Dialog, Field as vfield, Icon as vicon, Tag as vtag, Radio as vradio, RadioGroup as vradiogroup, Toast } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `ScoreDetail`,
    components: { vnavbar, Empty, vbutton, vradio, [Dialog.Component.name]: Dialog.Component, vfield, vicon, vtag, vradiogroup, Toast },
    data() {
        return {
            surgeryId: parseInt(this.$route.query.surgeryId),
            scoreId: parseInt(this.$route.params.scoreId),
            surgeryInfo: this.$route.params.surgeryInfo,
            isShowMore: false,
            loading: false,
            finished: false,
            refreshing: false,
            scoreList: [
                {
                    id: 1,
                    name: `压疮危险因素Braden评分`,
                    remark: `评分范围222：6~23分；轻度危险：15~18分；中度危险：13~14分；高度危险：10~12分；极度危险：< 9分`,
                    details: [{
                        id: 1,
                        question: `感觉`,
                        options: [{ value: 1, lable: `【1分】完全受限` },
                            { value: 2, lable: `【2分】非常受限` },
                            { value: 3, lable: `【3分】轻度受限` },
                            { value: 4, lable: `【4分】未受损害` }]
                    }, {
                        id: 2,
                        question: `潮湿`,
                        options: [{ value: 1, lable: `【1分】持久潮湿` },
                            { value: 2, lable: `【2分】非常潮湿` },
                            { value: 3, lable: `【3分】偶尔潮湿` },
                            { value: 4, lable: `【4分】很少潮湿` }]
                    }, {
                        id: 3,
                        question: `活动`,
                        options: [{ value: 1, lable: `【1分】卧床不起` },
                            { value: 2, lable: `【2分】局限与椅` },
                            { value: 3, lable: `【3分】偶尔不行` },
                            { value: 4, lable: `【4分】经常步行` }]
                    }, {
                        id: 4,
                        question: `移动`,
                        options: [{ value: 1, lable: `【1分】完全不能` },
                            { value: 2, lable: `【2分】严重受限` },
                            { value: 3, lable: `【3分】轻度受限` },
                            { value: 4, lable: `【4分】不受限` }]
                    }, {
                        id: 5,
                        question: `营养`,
                        options: [{ value: 1, lable: `【1分】非常差` },
                            { value: 2, lable: `【2分】可能不足` },
                            { value: 3, lable: `【3分】适当` },
                            { value: 4, lable: `【4分】良好` }]
                    }, {
                        id: 6,
                        question: `摩擦和剪切力`,
                        options: [{ value: 1, lable: `【1分】有问题` },
                            { value: 2, lable: `【2分】有潜在问题` },
                            { value: 3, lable: `【3分】无明显问题` }]
                    }]
                },
                {
                    id: 2,
                    name: `创伤TS评分`,
                    details: [{
                        id: 1,
                        question: `呼吸次数(次/分)`,
                        options: [{ value: 1, lable: `【1分】小于10` },
                            { value: 2, lable: `【2分】大于35` },
                            { value: 3, lable: `【3分】25-35` },
                            { value: 4, lable: `【4分】10-24` }]
                    }, {
                        id: 2,
                        question: `呼吸困难`,
                        options: [{ value: 0, lable: `【0分】浅或困难` },
                            { value: 1, lable: `【1分】正常` }]
                    }, {
                        id: 3,
                        question: `循环收缩压(mmHg)`,
                        options: [{ value: 1, lable: `【1分】小于50` },
                            { value: 2, lable: `【2分】50-69` },
                            { value: 3, lable: `【3分】70-90` },
                            { value: 4, lable: `【4分】大于90` }]
                    }, {
                        id: 4,
                        question: `毛细血管充盈`,
                        options: [{ value: 0, lable: `【0分】无充盈` },
                            { value: 1, lable: `【1分】充盈迟缓` },
                            { value: 2, lable: `【2分】正常` }]
                    }, {
                        id: 5,
                        question: `意识状态(GCS)`,
                        options: [{ value: 1, lable: `【1分】3-4` },
                            { value: 2, lable: `【2分】5-7` },
                            { value: 3, lable: `【3分】8-10` },
                            { value: 4, lable: `【4分】11-13` },
                            { value: 5, lable: `【5分】14-15` }]
                    }]
                },
                {
                    id: 3,
                    name: `ASA病情分级`,
                    details: [{
                        id: 1,
                        question: ``,
                        options: [{ value: `I`, lable: `【I级】体格健康，行一般手术 病死率(%)：0.06~0.08 提示：病人对麻醉和手术的耐受性良好，风险性较小` },
                            { value: `II`, lable: `【II级】除外科疾病外，有轻度并存病，代偿功能健全 病死率(%)：0.27~0.40 提示：病人对麻醉和手术的耐受性良好，风险性较小` },
                            { value: `III`, lable: `【III级】并存病较严重，体力活动受限，但尚能应付日常工作 病死率(%)：1.82~4.30 提示：病人的器官功能虽在代偿范围内，但对麻醉和手术的耐受能力降低，风险性较大，如术前准备充分，尚能耐受麻醉` },
                            { value: `IV`, lable: `【IV级】并存病严重，丧失日常工作能力，经常面临生命威胁 病死率(%)：7.80~23.0 提示：病人因器官功能代偿不全，麻醉和手术的风险性很大，即使术前准备充分，围手术期的病死率仍很高` },
                            { value: `V`, lable: `【V级】无论手术与否，生命难以维持24h的濒死病人 病死率(%)：9.40~50.7 提示：病人为濒死病人，麻醉和手术都异常危险，不宜行择期手术` },
                            { value: `VI`, lable: `【VI级】确证为脑死亡 ，其器官拟用于器官移植手术。` }]
                    }]
                }
            ],
            scoreInfo: {},
            ScoreSum: 0
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`])
    },
    created() {
        this.getScoreInfo()
        this.getScoreSum()
    },
    mounted() {},
    methods: {
        back() {
            this.$router.push({ name: `ScoreInfo`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo } }).catch(err => err)
            // this.$router.go(-1)
        },
        onLoad() {
        },
        onRefresh() {
            let that = this
            that.refreshing = false
        },
        getScoreInfo() {
            let that = this
            this.$store.dispatch(`ADD_CURRENTUSER`)
            let allscoreList = JSON.parse(localStorage.getItem(`allscoreList`)) || []
            let scoreResult = allscoreList && _.find(allscoreList, { surgeryId: this.surgeryId, scoreId: this.scoreId })
            that.scoreInfo = _.find(that.scoreList, { id: that.scoreId })
            that.scoreInfo.score = scoreResult && scoreResult.result
            that.scoreInfo.details = that.scoreInfo.details && _.map(that.scoreInfo.details, (d, index) => {
                var item = scoreResult && _.find(scoreResult.details, { id: d.id })
                d.value = item && item.value
                return d
            })
        },
        scoreClick(item, scorevalue) {
            let that = this
            that.scoreInfo.details = that.scoreInfo.details && _.map(that.scoreInfo.details, (d, index) => {
                if (d.id == item.id) {
                    d.value = scorevalue
                }
                return d
            })
            this.getScoreSum()
        },
        getScoreSum() {
            let score = `0`
            if (this.scoreInfo.details.length > 1) {
                this.scoreInfo.details.forEach(d => {
                    if (d.value) {
                        score = parseInt(score) + parseInt(d.value)
                    }
                })
            } else {
                score = this.scoreInfo.details[0].value
            }
            this.ScoreSum = score
        },
        savescore() {
            let that = this
            let allscoreList = JSON.parse(localStorage.getItem(`allscoreList`)) || []
            let scoreResult = _.find(allscoreList, { surgeryId: that.surgeryId, scoreId: that.scoreId })
            let details = []
            that.scoreInfo.details.map(item => {
                details.push({
                    id: item.id,
                    value: item.value
                })
            })
            if (scoreResult) {
                allscoreList = _.map(allscoreList, (d, index) => {
                    if (d.surgeryId == that.surgeryId && d.scoreId == that.scoreId) {
                        d.result = that.ScoreSum
                        d.details = details
                    }
                    return d
                })
            } else {
                allscoreList.push({
                    surgeryId: that.surgeryId,
                    scoreId: that.scoreId,
                    result: that.ScoreSum,
                    details: details
                })
            }
            window.localStorage.setItem(`allscoreList`, JSON.stringify(allscoreList))

            console.log(`allscoreList`, allscoreList)
            Toast(`保存成功`)
            this.$router.push({ name: `ScoreInfo`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo } }).catch(err => err)
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_scoreDetail`) {
                this.surgeryId = parseInt(this.$route.query.surgeryId)
                this.scoreId = parseInt(this.$route.params.scoreId)
                this.surgeryInfo = this.$route.params.surgeryInfo
                this.getScoreInfo()
                this.getScoreSum()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnSave {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 0px;
        color: #ffffff;
    }
    .lblScore {
        flex:1;
        background: aliceblue;
        margin: 5px;
        height: 40px;
        padding: 10px 0px;
        font-size: large;
        color: black;
    }
}

.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/ScoreDetail.vue